import type { Faq } from '../types/kit';

export const faqs: Faq[] = [
  {
    question: 'What exactly is included?',
    answer:
      'Volume 1: Play, Connect & Cooperate, with 13 complete weekly sessions, plus the five bonuses listed above. Each weekly session includes preparation, materials, read-aloud guidance, timed steps, resources and adaptations.',
  },
  {
    question: 'Does this include a full year of 52 sessions?',
    answer:
      'This offer covers weeks 1–13 only. Volume 1 is the first part of a planned annual series. Other volumes are not included in this purchase, and this page does not promise delivery of future volumes.',
  },
  {
    question: 'Who is it designed for?',
    answer:
      'Adult coordinators of after-school clubs, play centers, children’s clubs and recreational workshops for ages 5–8. The plans use 12 children as the working example, with guidance for adapting to groups of 6–16.',
  },
  {
    question: 'How much preparation do I still need?',
    answer:
      'The planning is supplied. You review the session, check suitability, gather the materials, print or cut the resources and prepare the space. Preparation time varies with the session and your group.',
  },
  {
    question: 'How long is each encounter?',
    answer:
      'Approximately 45 minutes, including explanations, transitions, resetting and closing. Timings are planning estimates; adjust the pace and repeat rounds to suit your group.',
  },
  {
    question: 'What materials will I need?',
    answer:
      'Everyday supplies such as paper, crayons, paper cups, large lightweight blocks, painter’s tape and soft balls. Each plan gives its own materials and quantities. Physical supplies are not included.',
  },
  {
    question: 'Is this a physical book? What language is it in?',
    answer:
      'It is a digital product in English, with resources you can print. No physical books or equipment are shipped. It supports supervised recreation and is not a formal English-teaching curriculum.',
  },
  {
    question: 'How will I receive it? Do I need an account?',
    answer:
      'After payment is approved, Impul sends an email with the download links. Downloads are also available on the order’s confirmation page. You do not need a buyer account or password. Save the files to your own device; no lifetime hosting period is promised here.',
  },
  {
    question: 'How do payment and currency work?',
    answer:
      'The package is a one-time purchase. Payment is processed through Stripe. The checkout displays the available payment methods and your final amount and currency before you pay.',
  },
  {
    question: 'What is the return policy?',
    answer:
      'The current store policy states: “If this isn’t the right fit for your planning style, request a return within 10 days. We’ll help you make it right.” This page does not add any automatic-refund or keep-the-bonuses promise.',
  },
];
